import { features, icons, productSample } from "@resourcehub/resourcehub-assets";
import awards from "../../shared/us.awards";
import branded_quotes from "../../shared/us.branded_quotes";
import verticals from "./us-education-secondary.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "us-education-secondary-404":
            return {
                page,
                helmet: {
                    meta_title: "Page Not Found | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.com/highereducation/404",
                    lang: "en"
                },
                eloquaPage: "resources",
                ...pageFooter({ strings })
            };
        case "us-education-secondary-contact":
            return {
                page,
                helmet: {
                    meta_title: "Contact | Rosetta Stone",
                    meta_description:
                        "Global professional services and consulting firms are met with language barriers that limit their ability to serve customers, engage employees, and grow their business globally. Language training solutions help professional consulting firms maximize billable hours per employee—proving out meaningful language training ROI across the organization.",
                    canonical_url: "https://www.rosettastone.com/hed/contact/",
                    lang: "en"
                },
                eloquaPage: "webpage",
                ...pageFooter({ strings })
            };
        case "us-education-secondary-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "Online Language Learning for Higher Ed | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
                    canonical_url: "https://www.rosettastone.com/highereducation/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "us-education-secondary-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "Resources for Online Language Learning for Higher Ed | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
                    canonical_url: "https://www.rosettastone.com/highereducation/resources/",
                    lang: "en"
                },
                ...pageFooter({ strings })
            };
        case "us-education-secondary-home":
            return {
                page,
                helmet: {
                    meta_title: "Online Language Learning for Higher Ed | Rosetta Stone",
                    meta_description:
                        "Rosetta Stone language learning solutions for higher education give students instant online access to learn English and world languages. Ask about pricing.",
                    canonical_url: "https://www.rosettastone.com/highereducation/",
                    lang: "en"
                },
                content: {
                    sections: [
                        {
                            data_qa: "section1_hero",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Students create global connections with a swipe on their smartphone. Yet, schools face world language budget constraints. This limits students’ potential academic and career choices, and their worldview. In a global economy, world language skills are a 21st century job requirement."
                                    },
                                    custom: {
                                        cta_1: {
                                            destination: "https://business.rosettastone.com/us-pricing-request/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Watch Video",
                                            theme: "blue_white"
                                        },
                                        cta_2: {
                                            destination: "https://business.rosettastone.com/us-pricing-request/",
                                            new_window: false,
                                            size: "regular",
                                            text: "Request Pricing",
                                            theme: "yellow_black"
                                        }
                                    },
                                    direction: "image-right",
                                    image: {
                                        width: "50vw"
                                    },
                                    title: {
                                        align: "left",
                                        content: "Put language learning within every student’s reach",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "section2_productSample",
                            panels: [
                                {
                                    title: { align: "left", content: "Accelerate English language learning." },
                                    body: {
                                        content:
                                            "Many higher education students can pass a standardized English-language proficiency test; however, the language skills required to be successful in academia are often much different. Rosetta Stone language learning solutions help build international students' English confidence and prepare them for success."
                                    },
                                    panels: [
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    asset_static: productSample.azulPng
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    asset_static: productSample.verdePng
                                                }
                                            },
                                            challenge_text: "Azul"
                                        },
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    asset_static: productSample.bicicletaAzulPng
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    asset_static: productSample.bicicletaAmarillaPng
                                                }
                                            },
                                            challenge_text: "Una bicicleta azul"
                                        },
                                        {
                                            left_option: {
                                                is_correct: true,
                                                image: {
                                                    asset_static: productSample.dosBicicletasAzulesPng
                                                }
                                            },
                                            right_option: {
                                                is_correct: false,
                                                image: {
                                                    asset_static: productSample.dosBicicletasDiferentesPng
                                                }
                                            },
                                            challenge_text: "Dos bicicletas azules"
                                        },
                                        {
                                            left_option: {
                                                is_correct: false,
                                                image: {
                                                    asset_static: productSample.verdesPorUnDiaPng
                                                }
                                            },
                                            right_option: {
                                                is_correct: true,
                                                image: {
                                                    asset_static: productSample.azulesPorUnDiaPng
                                                }
                                            },
                                            challenge_text: "Dos bicicletas azules por un día por favor"
                                        }
                                    ],
                                    custom: {
                                        quote_attribution_1: {
                                            quote:
                                                "In this Internet era, English being the global language, students need to master this language to be confident and to stay competitive in their studies now and later in their profession.",
                                            attribution:
                                                "Dean, Deanship of Preparatory Year & Supportive Studies, Northern Border University",
                                            size: "small",
                                            align: "left",
                                            link: {
                                                align: "left",
                                                theme: "black",
                                                destination:
                                                    "https://www.rosettastone.com/k12/resources/content/case-study-northern-border-university/"
                                            }
                                        }
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "section3_image",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "That’s no surprise. Culture, entertainment, sports, and literature are only a click away. Blending award-winning e-learning into your language curriculum gives students online access to unlimited pronunciation guidance and speaking practice that’s not possible during classroom hours."
                                    },
                                    custom: {
                                        quote_attribution_1: {
                                            quote:
                                                "After we piloted our conversational language courses, our students took the American Council on the Teaching of Foreign Languages’ (ACTFL) Oral Proficiency Interview (OPIc). After just one semester of study, students in the 101 courses scored at the Novice-Mid level or higher on the OPIc.",
                                            attribution:
                                                "Department Chair, College of General Studies, Liberty University",
                                            align: "left",
                                            size: "small",
                                            link: {
                                                align: "left",
                                                theme: "black",
                                                destination:
                                                    "https://www.rosettastone.com/k12/resources/content/case-study-liberty-university/"
                                            }
                                        }
                                    },
                                    direction: "image-right",
                                    image: {},
                                    title: {
                                        align: "left",
                                        content: "Online is students’ home away from home",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "section4_image",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Students, instructors, and staff all want to feel at ease speaking a new language. Moving from language learning to the real world takes practice. With our 1:1 and small group tutoring sessions, learners converse with native speakers. That makes tutoring in our friendly online space a smart way to learn."
                                    },
                                    custom: {
                                        quote_attribution_1: {
                                            quote:
                                                "Rosetta Stone solutions have been a great tool to help the participants assess their levels and access a range of interactive and diversified learning experiences which promotes independent progress.",
                                            attribution: "Course Coordinator, Canterbury Christ Church University",
                                            link: {
                                                align: "left",
                                                theme: "black",
                                                destination:
                                                    "https://www.rosettastone.com/k12/resources/content/case-study-canterbury-christ-church-university/"
                                            },
                                            align: "left",
                                            size: "small"
                                        }
                                    },
                                    direction: "image-left",
                                    image: {},
                                    title: {
                                        align: "left",
                                        content: "Unlimited Live Tutoring gets learners talking",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "section5_image",
                            layout: "list",
                            panels: [
                                {
                                    body: {
                                        content:
                                            "Class schedules are still the norm for students. But schools are also making it easier to learn away from the classroom. Our mobile app lets your students access lessons and activities whenever the time is right. Giving them the freedom to turn any moment into a teachable one."
                                    },
                                    custom: {
                                        quote_attribution_1: {
                                            quote:
                                                "We see those students who follow the Rosetta Stone® program become motivated and confident, more willing to participate in classroom activities, and acquire vocabulary at a much faster rate.",
                                            attribution: "ELL Teacher, Phoenix Union High School District",
                                            align: "left",
                                            size: "small",
                                            link: {
                                                align: "left",
                                                theme: "black",
                                                destination:
                                                    "https://www.rosettastone.com/k12/resources/content/customer-spotlight-phoenix-union-high-school-district/"
                                            }
                                        }
                                    },
                                    direction: "image-right",
                                    image: {},
                                    title: {
                                        align: "left",
                                        content: "Mobile learning, online or off",
                                        theme: "black",
                                        type: "section-title"
                                    }
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "section6_contact",
                            sub_title: {
                                align: "center",
                                content: "Please fill out the form below and we'll follow up with you right away.",
                                theme: "white",
                                type: "sub-title"
                            },
                            thanks: "Thanks for your interest! Someone will follow up with you shortly.",
                            title: {
                                align: "center",
                                content: "Get the pricing answers you need.",
                                theme: "white",
                                type: "section-title"
                            },
                            visible: true
                        },
                        {
                            data_qa: "section7_features",
                            layout: "list",
                            panels: [
                                {
                                    features: [
                                        {
                                            feature: {
                                                label: "24 Languages",
                                                description: "English and World Languages to match student goals.",
                                                icon: {
                                                    asset_static: icons.icon_24Svg
                                                }
                                            },
                                            media: {
                                                asset_static: features.featuresPhoneLanguagesPng
                                            }
                                        },
                                        {
                                            feature: {
                                                label: "Self-paced Immersion",
                                                description:
                                                    "Surrounding students with one language speeds up learning.",
                                                icon: {
                                                    asset_static: icons.iconProficiencySvg
                                                }
                                            },
                                            media: {
                                                asset_static: features.featuresPhoneImmersionPng
                                            }
                                        },
                                        {
                                            feature: {
                                                label: "Games and Activities",
                                                description:
                                                    "Students have fun while reinforcing lessons they’ve learned.",
                                                icon: {
                                                    asset_static: icons.iconGamesSvg
                                                }
                                            },
                                            media: {
                                                asset_static: features.featuresPhoneActivitiesPng
                                            }
                                        },
                                        {
                                            feature: {
                                                label: "TruAccent™ Speech Recognition",
                                                description: "It’s the pronunciation helper any student can use.",
                                                icon: {
                                                    asset_static: icons.iconTruaccentSvg
                                                }
                                            },
                                            media: {
                                                asset_static: features.featuresPhoneTruaccentPng
                                            }
                                        },
                                        {
                                            feature: {
                                                label: "Live Tutoring",
                                                description: "Offered in a safe, online space at each student’s level.",
                                                icon: {
                                                    asset_static: icons.iconTutoringSvg
                                                }
                                            },
                                            media: {
                                                asset_static: features.featuresPhoneTutoringPng
                                            }
                                        },
                                        {
                                            feature: {
                                                label: "Mobile App",
                                                description: "Puts learning access in each student’s hand.",
                                                icon: {
                                                    asset_static: icons.iconMobileSvg
                                                }
                                            },
                                            media: {
                                                asset_static: features.featuresPhoneMobilePng
                                            }
                                        }
                                    ]
                                }
                            ],
                            visible: true
                        },
                        {
                            data_qa: "section8_relatedResources",
                            default_button_label: strings.related_resources_button_label,
                            panels: [],
                            resource_ids: [
                                "recqx7Gp85JxbWVUk",
                                "recmZCtDOwebYHRXw",
                                "reclyhXd1Wt8SDAkv",
                                "recBdyJF9DHfMJX4Y"
                            ],
                            resources_url: "/resources/",
                            title: {
                                align: "center",
                                content: strings.related_resources_label,
                                theme: "black",
                                type: "section-title"
                            },
                            visible: true
                        }
                    ]
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
